// extracted by mini-css-extract-plugin
export var assets = "cosmoParallaxSymbols-module--assets--c4428";
export var cosmoParallaxSymbols = "cosmoParallaxSymbols-module--cosmoParallaxSymbols--af1ea";
export var symbol = "cosmoParallaxSymbols-module--symbol--04af3";